module.exports = __webpack_public_path__ + "static/img/xj-logo.d518e376.png";